// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_in-5";
export var filledCircle = "_in-4";
export var historyEntry = "_in-3";
export var messageSideLeft = "_in-1";
export var messageSideRight = "_in-2";
export var orderTrackingInfoContainer = "_in-0";